<template>
  <collapsible-widget
    title="ANALIZA KOSZTÓW ZA WYKORZYSTANIE SŁUPÓW"
    :accordion="accordion"
    :default-expanded="true"
  >
    <b-form class="p-2 pt-4 pb-4">
      <b-form-row v-if="stakeIsEmpty">
        <b-col>
          <b-alert variant="danger" :show="stakeIsEmpty"
            ><strong>Uwaga.</strong> Formularz zawiera błędy.</b-alert
          >
        </b-col>
      </b-form-row>
      <b-form-row v-if="stakeIsEmpty">
        <b-col offset="4" cols="8">
          <small class="text-danger">Należy podać stawkę.</small>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols="4">
          <label>Stawka</label>
        </b-col>
        <b-col cols="8">
          <b-form-input
            id="stake"
            v-model.number="stake"
            placeholder="Wpisz"
            type="number"
            step="0.01"
            min="0"
            :state="stakeIsEmpty ? false : null"
          ></b-form-input>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols="4">
          <label>Liczba obiektów</label>
        </b-col>
        <b-col cols="8">
          {{ numberOfPoles }}
        </b-col>
      </b-form-row>
      <b-form-row
        ><b-col cols><hr /></b-col
      ></b-form-row>
      <b-form-row>
        <b-col cols="4">
          <label>Wynik</label>
        </b-col>
        <b-col cols="8">
          {{ result }}
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols>
          <b-btn
            class="col-md-12"
            variant="primary"
            @click.stop="calculate(false)"
            >Oblicz</b-btn
          >
        </b-col>
        <b-col cols>
          <b-btn
            class="col-md-12"
            variant="primary"
            @click.stop="calculate(true)"
            >Generuj raport</b-btn
          >
        </b-col>
        <b-col cols>
          <b-btn class="col-md-12" variant="outline-secondary" @click="cancel"
            >Anuluj</b-btn
          >
        </b-col>
      </b-form-row>
    </b-form>
  </collapsible-widget>
</template>

<script>
import CollapsibleWidget from './CollapsibleWidget';
// import ObjectGeometry from './MapObjectsGeometry';
import {
  CALCULATE_POLE_ANALYSIS,
  CANCEL_POLE_ANALYSIS
} from '../store/actions.type';

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget
  },
  data() {
    return {
      stake: null,
      stakeIsEmpty: false
    };
  },
  computed: {
    numberOfPoles() {
      return this.$store.getters.numberOfPoles === null
        ? '-'
        : this.$store.getters.numberOfPoles;
    },
    result() {
      return this.$store.getters.polesAnalysisResult
        ? this.$store.getters.polesAnalysisResult
        : '-';
    }
  },
  methods: {
    async calculate(generateReport) {
      this.stakeIsEmpty = this.stake === null || this.stake === '';
      if (!this.stakeIsEmpty) {
        const result = await this.$store.dispatch(CALCULATE_POLE_ANALYSIS, {
          stake: this.stake,
          generateReport: generateReport
        });

        if (result && generateReport) {
          this.$notify({
            type: 'info',
            title: 'Informacja.',
            text:
              'Raport zostanie automatycznie pobrany po jego wygenerowaniu.',
            duration: 2000
          });
        }
      }
    },
    cancel() {
      this.$store.dispatch(CANCEL_POLE_ANALYSIS);
    }
  }
};
</script>
